export default __webpack_public_path__ + "static/media/trash.5f6b5471.svg";